let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'
export { urlAlphabet }



//////////////////
// WEBPACK FOOTER
// ../~/nanoid/url-alphabet/index.js
// module id = 1823
// module chunks = 1